import { CompanyUser, QesStatus } from '__generated__/GQL';

import { VerificationStatus } from '../../Verification/lib/steps/types';

interface GetQesStatusProps {
  companyUser: Pick<CompanyUser, 'qesStatus'>;
}

const QES_STATUS_TO_VERIFICATION_STATUS = {
  [QesStatus.NotNeeded]: VerificationStatus.Irrelevant,
  [QesStatus.Todo]: VerificationStatus.ToDo,
  [QesStatus.Invalid]: VerificationStatus.Invalid,
  [QesStatus.Ineligible]: VerificationStatus.Invalid,
  [QesStatus.AwaitingValidation]: VerificationStatus.Completed,
  [QesStatus.Signed]: VerificationStatus.Completed,
} satisfies Record<QesStatus, VerificationStatus>;

const getQesStatus = ({
  companyUser,
}: GetQesStatusProps): VerificationStatus => {
  return QES_STATUS_TO_VERIFICATION_STATUS[companyUser.qesStatus];
};

export default getQesStatus;
